module.exports = __webpack_public_path__ + "img/wally-bath.a3cdef84.png";